/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ratelimitSetOverride } from "../../funcs/ratelimitSetOverride.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.V2RatelimitSetOverrideRequestBody$inboundSchema,
};

export const tool$ratelimitSetOverride: ToolDefinition<typeof args> = {
  name: "ratelimit-set-override",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await ratelimitSetOverride(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
